export default __webpack_public_path__ + "static/media/new-msg.a6c054d5.mp3";